import { keepPreviousData } from "@tanstack/react-query";
import { RouterOutputs, trpc } from "../trpc";

export type FolderTreeItem =
  RouterOutputs["folder"]["folderTree"]["tree"][number];
export type FlatFolderTreeItem =
  RouterOutputs["folder"]["folderTree"]["hash"][string];

interface Options {
  enabled?: boolean;
}

export function useQueryFolderTree({ enabled = true }: Options = {}) {
  const { data, isLoading } = trpc.folder.folderTree.useQuery(
    {},
    {
      enabled,
      placeholderData: keepPreviousData,
      staleTime: 1000 * 60 * 5, // 5 minutes
      trpc: { context: { skipBatching: true } },
    },
  );
  const folders = data?.tree || ([] as FolderTreeItem[]);
  const hash = data?.hash || ({} as Record<string, FlatFolderTreeItem>);

  return {
    folders,
    hash,
    isFoldersLoading: isLoading,
  };
}
